import React from 'react'
import CustomAnchor from '../custom-anchor'

const NoteInfo = ({
    note = "",
    withInfoIcon = false,
    theme="light",
    anchorText,
    handleAnchorClick,
    anchorHref,
    anchorTarget = "_self"
}) => {
    return (
        <div className={`bimmatch-note-info note-info-${theme}`}>
            {withInfoIcon && <img src={`/images/icon/${theme === "light" ? "info-light": "info"}.svg`} className='info-icon' alt='info' />}
            <p className='note-info-message'>{note}</p>
            {anchorText && <CustomAnchor href={anchorHref} onClick={handleAnchorClick} target={anchorTarget}>{anchorText}</CustomAnchor>}
        </div>
    )
}

export default NoteInfo